var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"page-wrap"},[_c('DataBoard'),_c('Company'),_c('Business'),_c('News'),_c('Service')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }